import React, { useEffect } from "react";
import video1 from "../video/video1.mp4";
import Menu from "../components/Menu";
import Sidebox from "../components/Sidebox";
import Aboutus from "./Aboutus";
import Education from "./Education";
import Service from "./Service";
import Skills from "./Skills";
import Featuredproject from "./Featuredproject";
import Testimonial from "./Testimonial";
import Price from "./Price";
import Contactus from "./Contactus";
import Frontcontent from "./Frontcontent";
import Aos from "aos"
import ScrollUpButton from "react-scroll-up-button";
import { BsFacebook,BsInstagram } from "react-icons/bs";
import { AiOutlineLinkedin,AiOutlineYoutube } from "react-icons/ai";
const Home = () => {
  useEffect(()=>{
  Aos.init({duration:2000});
  });
  return (
    <div className="home1-page">
      <div>
        <video
        className="customervideo"
          muted
          autoPlay
          loop
        >
          <source src="assets/images/video1.mp4" type="video/mp4" />
        </video>
        <div className="page-loader">
          <div className="bounceball" />
        </div>
        <span className="icon-menu">
          <span className="bar" />
          <span className="bar" />
        </span>
        <Menu />
        <Sidebox />
        <main className="drake-main">
          <div id="smooth-wrapper">
            <div id="smooth-content">
              <div className="left-sidebar" >
                <div className="sidebar-header d-flex align-items-center justify-content-between">
                  <h1 data-aos="fade-right" >
                   Portfo<span style={{color:"#00693E"}}>lio</span>
                  </h1>
                </div>
                <img className="me" src="assets/images/me.jpg" alt="Me" />
                <h2 className="email">Azy6049@gmail.com</h2>
                <ul className="social-profile d-flex align-items-center flex-wrap justify-content-center">
                <li>
        <a target='_blank' href="https://www.facebook.com/profile.php?id=100092541834834&mibextid=ZbWKwL"><BsFacebook size={30} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.instagram.com/ajaybairwa4273/"><BsInstagram size={27} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.linkedin.com/in/ajay-bairwa-269921280/"><AiOutlineLinkedin size={30} /></a>
      </li>
      <li>
        <a target='_blank' href="https://www.youtube.com/@WebMastery009/about"><AiOutlineYoutube size={30}/></a>
      </li>
                </ul>
                <a href="#" className="theme-btn">
                  <i className="las la-envelope" /> Hire Me!
                </a>
              </div>
              <Frontcontent />
              <Skills />
              <Aboutus />
              <Education />
              <Service />
              <Featuredproject />
              <Testimonial />
              <Contactus />
              <div>
  <aside role="button" aria-label="Scroll to top of page" tabIndex={0} data-testid="react-scroll-up-button" className="ScrollUpButton__Container ScrollUpButton__Toggled" style={{ height: 50, position: 'fixed', bottom: 20, width: 50, transition: 'opacity 0.5s ease-in-out 0s, right', cursor: 'pointer', opacity: 1, right: 20, zIndex: 1000, color: 'rgb(0, 105, 62)'}}><a href="https://wa.me/918178609471" target="_blank"><img src="assets/images/wa.png" alt="Framer"  /></a></aside>
</div>


              <div>
              <ScrollUpButton ContainerClassName="ScrollUpButton__Container" TransitionClassName="ScrollUpButton__Toggled" style={{color:"#00693e",bottom:76}}>
                </ScrollUpButton>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Home;
